export const getIdentityToken = () => {
  const urlSearchParams = new URLSearchParams(window.location.search);
  return urlSearchParams.get('identityToken');
};
